// Module
var code = "<products on-success=\"onSuccess\" on-error=\"onError\" ui-router=\"uiRouter\"/> ";
// Exports
var _module_exports = code;;
var path = '/admin/store/products.html';
var angular = require('angular');
angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;